import useSWRMutation from "swr/mutation";
import { FetcherArg, fetcherPost } from "./httpClient";
import { useAuth } from "../../context/AuthProvider";
import type { CreateJobRequest } from "../contracts/CreateJobRequest";

export const useCreateJob = () => {
  const { session } = useAuth();
  return useSWRMutation<
    any,
    Error,
    string,
    Omit<FetcherArg<CreateJobRequest>, "token">
  >("jobs", async (url: string, { arg }) =>
    fetcherPost<CreateJobRequest, any>(url, {
      arg: { ...arg },
      token: session?.access_token ?? "",
    }),
  );
};
